import { distributeToStreams } from './distribute-to-streams'
import { LabelInfo } from './get-recomendations'
import getRolls from './get-rolls'

export interface Strategy {
    title: string
    copies: number
    winding: number
    cols: number
    rolls: [number, number][] // [copies, rolls]
}

/**
 * Функция получения стратегии
 *
 * @param info - инфо по этикетке и кол-ву
 * @param winding - намотка
 * @param cols - кол-во руьев
 * @param title - наименование стратегии
 * @returns стратегию
 */
export function getStrategy(
    info: LabelInfo,
    winding: number,
    cols: number,
    title: string
): Strategy {
    // console.log('winding', winding)
    const res = distributeToStreams(info, cols)
    const rolls = getRolls(res, winding)

    return {
        title: title,
        copies: info[1],
        winding: winding,
        cols: res.length,
        rolls: [...rolls.entries()],
    }
}
